<template>
  <div>
    <div class="row">
      <div class="col-xl-4 col-lg-5 col-md-6">
        <reprint-form> </reprint-form>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-11 col-md-10">
        <order-list></order-list>
      </div>
    </div>
  </div>
</template>
<script>
import ReprintForm from "./Reprint/ReprintForm.vue";
import OrderList from "@/pages/OrderList.vue";
export default {
  components: {
    ReprintForm,
    OrderList,
  },
};
</script>
<style>
</style>
